/** @jsxImportSource @emotion/react */
import { selectTeams } from 'modules/main/store/main-page';
import AvatarGroup from 'modules/main/ui/components/section/components/avatar-group/avatar-group';
import ValueGroup from 'modules/main/ui/components/section/components/value-group/value-group';
import Section from 'modules/main/ui/components/section/section';
import { Pages } from 'modules/navigation/domain/enums/pages';
import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { theme } from 'styles/theme/theme';
import type { DivProps } from 'typings';
import TeamsAddIcon from 'ud-ui/components/icon/teams-add-icon';
import Text from 'ud-ui/components/text';

interface IProps extends DivProps {
  loading?: boolean;
}

function SectionTeams(props: IProps) {
  const { loading, ...rest } = props;
  const navigate = useNavigate();
  const { total, declared, popular } = useSelector(selectTeams);
  const overflow = Math.max(total - popular.length, 0);

  const values = [
    { label: 'всего', value: total.toString() },
    { label: 'заявлены', value: declared.toString() },
  ];

  return (
    <Section
      icon={<TeamsAddIcon />}
      header="Команды"
      buttonText="Добавить команду"
      isShowButton={total === 0}
      onClickButton={() => navigate(Pages.TEAMS.CREATE)}
      onClickExtend={() => navigate(Pages.TEAMS.INDEX)}
      loading={loading}
      {...rest}
    >
      <ValueGroup values={values} className="mb-5" />
      {popular.length ? (
        <div className="flex flex-col gap-3">
          <div className="flex-column">
            <Text isNew type="body-1" color={theme.colors.Gray}>
              Популярные
            </Text>
            <Text isNew type="subtitle-2" color={theme.colors.WhiteGray}>
              Часто участвуют в турнирах
            </Text>
          </div>
          <AvatarGroup avatars={popular.map((item) => item.image)} overflowIndicator={overflow !== 0 ? overflow : undefined} />
        </div>
      ) : (
        <div className="flex-column">
          <Text isNew type="body-1" color={theme.colors.Gray}>
            Популярные
          </Text>
          <Text isNew type="subtitle-2" color={theme.colors.WhiteGray}>
            В списке нет команд
          </Text>
        </div>
      )}
    </Section>
  );
}

export default SectionTeams;
